<script lang="ts">
    import { Col, Label } from "sveltestrap";
    import { SwitchColor } from "../../../../utils/Constant/Constant";
    import {switchdata} from "../../../../Data/Forms/Widgets/Widgets"
    import Card from "../../../Core/Card.svelte";
</script>
<Col sm="12" xl="6" lg="12" md="6">
    <Card headerTitle={SwitchColor} cardBodyprops="row switch-showcase height-equal" cardHeaderprops="pb-0">
      <div slot="contentbody">
        <Col sm="12">
            {#each switchdata as switchItem}
                <div class="media">
                    <Label class="col-form-label m-r-10">{switchItem.name}</Label>
                    <div class="media-body text-end icon-state">
                        <Label class="switch">
                            <input type="checkbox" checked>
                            <span class="switch-state bg-{switchItem.color}"></span>
                        </Label>
                    </div>
                </div>
            {/each}
        </Col>
      </div>
    </Card>
</Col>